import { createSlice } from '@reduxjs/toolkit';
import { createTerm, fetchTerms, deleteTerm, updateTerm, fetchTermDetails } from './actions';

const initialState = {
  terms: [],
  selectedTerm: null,
  loading: false,
  error: null,
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
  },
};

const termsSlice = createSlice({
  name: 'terms',
  initialState,
  reducers: {
    clearSelectedTerm: (state) => {
      state.selectedTerm = null;
    },
  },
  extraReducers: (builder) => {
    // Fetch terms
    builder.addCase(fetchTerms.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchTerms.fulfilled, (state, action) => {
      state.terms = action.payload.terms;
      state.pagination = action.payload.pagination;
      state.loading = false;
    });
    builder.addCase(fetchTerms.rejected, (state, action) => {
      state.error = action.error.message;
      state.loading = false;
    });

    // Create term
    builder
      .addCase(createTerm.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createTerm.fulfilled, (state, action) => {
        state.terms.push(action.payload);
        state.loading = false;
      })
      .addCase(createTerm.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    // Other cases for update, delete, etc.

    // Fetch term details
    builder
      .addCase(fetchTermDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTermDetails.fulfilled, (state, action) => {
        state.selectedTerm = action.payload;
        state.loading = false;
      })
      .addCase(fetchTermDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    // Update term
    builder
      .addCase(updateTerm.pending, (state) => {
        // state.loading = true;
        state.error = null;
      })
      .addCase(updateTerm.fulfilled, (state, action) => {
        // state.loading = false;
        // Update the term in the terms array if it exists
        const index = state.terms.findIndex(term => term._id === action.payload._id);
        if (index !== -1) {
          state.terms[index] = action.payload;
        }
      })
      .addCase(updateTerm.rejected, (state, action) => {
        // state.loading = false;
        state.error = action.payload;
      });

    // Delete term
    builder
      .addCase(deleteTerm.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteTerm.fulfilled, (state, action) => {
        state.terms = state.terms.filter(term => term._id !== action.payload);
        state.loading = false;
      })
      .addCase(deleteTerm.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearSelectedTerm } = termsSlice.actions;
export default termsSlice.reducer;
